module.exports = __webpack_public_path__ + "img/fish_starfish.08106a6b.png";